import React from 'react';
import { Reveal } from '../Reveal';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';

/** Section 7 — the 6 core volumes as compact cover-colored rows. */
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-248" data-mp="3zv1mcy07fbo">
      <div className="mx-auto max-w-6xl" data-id="element-249" data-mp="81gazobbxbh4">
        <SectionHeading id="volumes-heading" title={<>
              Your Complete <Accent data-id="element-251" data-mp="10mzmm6zugcwm">Brow Education System</Accent>
            </>} data-id="element-250" data-mp="voobzu1q5ydc" />

        <ol className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-252" data-mp="mx5vfi0v9gjq">
          {volumes.map((volume, index) => <li key={volume.number} data-id="element-253" data-mp="qwoj2lk2o5q9" data-mpi={index}>
              <Reveal delay={index % 3 * 0.04} className="h-full" data-id="element-254" data-mp="qvvbxjh7be7l">
                <article className="flex h-full items-stretch gap-4 rounded-[18px] border border-brand-charcoal/8 bg-white p-3 shadow-[0_20px_40px_-34px_rgba(90,70,40,0.55)]" data-id="element-255" data-mp="1emiuqzsnno8x">
                  <div aria-hidden="true" className="relative flex w-[68px] flex-none flex-col items-center justify-center rounded-[12px]" style={{
                backgroundColor: volume.cover
              }} data-id="element-256" data-mp="cmay8f4d5azz">
                    <span className="absolute inset-y-2 left-1.5 w-px border-l border-dashed border-brand-charcoal/25" data-id="element-257" data-mp="hkmasxm1lzlw" />
                    <span className="font-body text-[9px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/60" data-id="element-258" data-mp="vazjx3ao7kct">
                      Vol
                    </span>
                    <span className="font-display text-[1.9rem] font-bold leading-none text-brand-charcoal" data-id="element-259" data-mp="159oqw1113kea">
                      {volume.number}
                    </span>
                  </div>
                  <div className="flex min-w-0 flex-col justify-center py-1.5 pr-2" data-id="element-260" data-mp="3711tgjfixg76">
                    <h3 className="font-display text-[1.2rem] font-bold leading-[1.18] text-brand-charcoal" data-id="element-261" data-mp="3734rnqqtyfmz">
                      <span className="sr-only" data-id="element-262" data-mp="15z2ddl7rmh54">Volume {volume.number}: </span>
                      {volume.series && <span className="block text-[1rem]" data-id="element-263" data-mp="1axdkvpal8fk6">
                          Brow Instructor <Accent data-id="element-264" data-mp="1f00g806gwim4">Ready</Accent>™
                        </span>}
                      {volume.title}
                    </h3>
                    <p className="mt-1.5 text-[13px] leading-snug text-brand-charcoal/60" data-id="element-265" data-mp="1k05102eerzi5">{volume.description}</p>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-266" data-mp="1ynq1dojwfkmd">
          <p className="font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-267" data-mp="1yo9ix45n06zv">
            6 Volumes. <Accent data-id="element-268" data-mp="22r5w2fcerawf">One Complete Teaching System.</Accent>
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-brand-charcoal/65 sm:text-[16px]" data-id="element-269" data-mp="27pzac9zir5xn">
            From first consultation to final student assessment.
          </p>
        </div>
      </div>
    </section>;
}